module.exports = __webpack_public_path__ + "8dd9adccb7af07735b5cb77c883efd36.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/TO.svg
// module id = eMQg
// module chunks = 0